import { DeleteObjectCommand, PutObjectCommand } from '@aws-sdk/client-s3';
import { ApiResponseFile, ParamsSeend, SendRquestParams } from '../interfaces';
import { s3Client } from '../s3-client';
import { getEnvs } from '../utils';

const { VITE_API_URL_AWS, VITE_BUCKET_BASE } = getEnvs();

export const erpApiFileAWT = () => {
  const sendRequest = async (method: string, params: SendRquestParams): Promise<ApiResponseFile> => {

    const { path, key, selectedFile } = params;

    try {
      let command;
      let params: ParamsSeend = {
        Bucket: VITE_BUCKET_BASE,
        Key: `${path}/${key}`,
      };

      if (selectedFile) {
        const fileBuffer = await selectedFile.arrayBuffer();

        params.Body = new Uint8Array(fileBuffer);
        params.ContentType = selectedFile.type;
        params.Metadata = {
          'name': `${selectedFile.name}`,
          'last-modified': `${selectedFile.lastModified}`,
          'size': `${selectedFile.size}`,
          'type': `${selectedFile.type}`,
          'web-kit-relative-path': `${selectedFile.webkitRelativePath}`,
        }
      }

      switch (method) {
        case 'PUT':
          command = new PutObjectCommand(params);
          const statusProccessPut = await s3Client.send(command);

          if (statusProccessPut?.$metadata?.httpStatusCode !== 200) {
            throw new Error(`Error al cargar los archivos.`);
          }

          const resPut = {
            code: statusProccessPut?.$metadata?.httpStatusCode!,
            statusText: 'OK',
            data: {
              url: `${VITE_API_URL_AWS}/${VITE_BUCKET_BASE}/${path}/${key}`,
              id_archivos: key.split('.')[0],
            },
          }
          return resPut;

        // console.log({revisandoPut:revisandoPut})
        // break;
        case 'DELETE':
          command = new DeleteObjectCommand(params);
          const statusProccessDelete = await s3Client.send(command);

          return {
            code: statusProccessDelete?.$metadata?.httpStatusCode!,
            statusText: 'OK',
            data: {
              url: `${VITE_API_URL_AWS}/${VITE_BUCKET_BASE}/${path}/${key}`,
              id_archivos: key.split('.')[0],
            },
          };
        // break;
        default:
          throw new Error(`Unsupported method: ${method}`);
      }

    } catch (error) {
      console.log("se fue al error")
      console.error('Error uploading file:', error);
      throw error;
    }
  };

  const put = (params: SendRquestParams): Promise<ApiResponseFile> => {
    return sendRequest('PUT', params);
  };

  const remove = (params: SendRquestParams): Promise<ApiResponseFile> => {
    return sendRequest('DELETE', params);
  };

  return { put, remove };
};
